import React from "react";
import { Table, Tag, Empty } from "antd";
import { RawMaterialPurchase, RawMaterialPurchaseItem } from "../../../Types";

const columns = [
  {
    title: "Material",
    key: "material",
    render: (_: any, rec: RawMaterialPurchaseItem) => (
      <div>
        <span className="font-medium text-gray-800 text-xs">
          {rec.raw_material_name}
        </span>
        <div className="text-[11px] text-gray-400">{rec.raw_material_code}</div>
      </div>
    ),
  },
  {
    title: "Batch",
    dataIndex: "batch_no",
    key: "batch_no",
    render: (v: string) => <Tag className="text-[11px]">{v || "N/A"}</Tag>,
  },
  {
    title: "Unit Cost",
    dataIndex: "cost_price",
    key: "cost_price",
    render: (v: number) => (
      <span className="text-xs text-gray-600">Rs. {v.toFixed(2)}</span>
    ),
  },
  {
    title: "Quantity",
    key: "quantity",
    render: (_: any, rec: RawMaterialPurchaseItem) => (
      <Tag color="orange" className="text-xs font-medium">
        {rec.quantity} {rec.raw_material_unit}
      </Tag>
    ),
  },
  {
    title: "Discount",
    dataIndex: "discount_percent",
    key: "discount_percent",
    render: (v: number) => <span className="text-xs text-gray-500">{v}%</span>,
  },
  {
    title: "Subtotal",
    dataIndex: "total",
    key: "total",
    render: (v: number) => (
      <span className="text-xs font-semibold text-gray-700">
        Rs. {v.toFixed(2)}
      </span>
    ),
  },
];

interface Props {
  record: RawMaterialPurchase;
}

export const PurchaseItemsTable: React.FC<Props> = ({ record }) => (
  <div className="px-4 py-3 bg-gray-50 rounded-md border border-gray-100 my-1">
    <h4 className="text-[11px] font-semibold text-gray-400 mb-2 uppercase tracking-wider">
      Purchased Items
    </h4>
    <Table
      dataSource={record.items || []}
      columns={columns}
      pagination={false}
      size="small"
      rowKey={(rec, idx) => rec.id || `item-${idx}`}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No items found."
          />
        ),
      }}
    />
  </div>
);
